import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { ErrorExtended } from '@models/error-extended';
import { ErrorForLogging } from '@models/error-for-logging';
import { UUID } from '@models/uuid';
import { BehaviorSubject, throwError } from 'rxjs';
import { auditTime, catchError } from 'rxjs/operators';
import { UserService } from './user.service';



@Injectable()
export class ErrorHandlerService implements ErrorHandler {
  REPORTING_DELAY_MILLIS = 10000;
  isPostSuccess = false;
  errorArray$: BehaviorSubject<ErrorForLogging[]>;
  constructor(private zone: NgZone, private userService: UserService, private http: HttpClient) { }

  init(): void {
    this.errorArray$ = new BehaviorSubject<ErrorForLogging[]>([]);
    this.zone.onError
      .subscribe((error: ErrorExtended) => {
        console.log(error);
        if (error.message !== 'Cannot connect to Error Logging Service' &&
          !error.message.includes('/web-app-svc/log/error')) {
          this.handleError(error);
        }
      });

    this.errorArray$.pipe(
      auditTime(this.REPORTING_DELAY_MILLIS)
    )
      .subscribe(errorArray => {
        if (errorArray.length) {
          this.sendErrorToApi(errorArray);
        }
      });
  }


  handleError(error: ErrorExtended) {
    if (!this.errorArray$) {
      this.init();
    }
    const extendedError = error as ErrorExtended;
    console.error(error);
    if (!extendedError.uuid) {
      let temp: ErrorForLogging[];
      if (this.isPostSuccess) {
        temp = [];
        this.isPostSuccess = false;
      } else {
        temp = this.errorArray$.getValue();
      }
      temp.push(this.buildError(error));
      this.errorArray$.next(temp);
    }

  }

  buildError(error: ErrorExtended): ErrorForLogging {
    let errorForLogging = new ErrorForLogging();
    errorForLogging.uuid = UUID.UUID();
    if (error.stack) {
      errorForLogging.message = error.stack;
    } else if (error.message) {
      errorForLogging.message = error.message;
    } else {
      errorForLogging.message = JSON.stringify(error);
    }

    if (this.userService.user && this.userService.user.employee) {
      errorForLogging.username = this.userService.user.employee.username;
    }

    if (error instanceof HttpErrorResponse) {
      errorForLogging.httpErrorCode = error.status;
    }

    errorForLogging.uri = error.url || window.location.href.split('#')[1] || '';
    errorForLogging.timestamp = (new Date()).getTime();
    return errorForLogging;
  }

  sendErrorToApi(errorArray: ErrorForLogging[]) {
    // TODO: need to verify recursive calls
   /* let url = '/web-app-svc/log/error';
    this.http.post(url, errorArray)
      .pipe(
        catchError(error => {
          this.resendErrorAfterDelay();
          let err = new Error();
          err.message = 'Cannot connect to Error Logging Service';
          return throwError(err);
        })
      )
      .subscribe(response => {
        this.isPostSuccess = true;
      });*/
  }

  resendErrorAfterDelay() {
    setTimeout(() => {
      this.sendErrorToApi(this.errorArray$.getValue());
    }, 10000);
  }

}


